import React, { useState } from "react";
import { IEditorProps } from '../Editor';
import { EditorLabel } from "../EditorLabel";
import { useScopeHandlers } from "./hooks/useScopeHandlers";
import { NumericFieldsFilter } from "components/inputs/data-filters/NumericFieldsFilter";
import { NumericFields } from "@decisions/server/DecisionsFramework/Design/Page/Filters";

export interface INumericFieldsFilterEditorProps extends IEditorProps {}

export function NumericFieldsFilterEditor({ child, path, onChange, hideInputLabel }: INumericFieldsFilterEditorProps) {
  const [value, setValue] = useState(child.Value.OutputValue as NumericFields);
  const onValueChange = (newValue: NumericFields) => {
    onChange(newValue, path);
    setValue(newValue);
  };

  const { personalization } = useScopeHandlers({ value, path, setValue, onChange });

    return (
        <EditorLabel
          editor={child}
          path={path}
          hideInputLabel={hideInputLabel}
          doNotWrap={true}
        >
          <NumericFieldsFilter value={value} onChange={onValueChange} personalization={personalization} />
        </EditorLabel>
      );
}